import { Graph, Shape } from '@antv/x6'
import tzj_model_stage1 from '@/assets/images/tzj_model/tzj_model_stage1.svg'
import tzj_model_stage2 from '@/assets/images/tzj_model/tzj_model_stage2.svg'
import tzj_model_stage3 from '@/assets/images/tzj_model/tzj_model_stage3.svg'
import tzj_model1_cube from '@/assets/images/tzj_model/tzj_model1_cube.svg'
import tzj_model1_energy from '@/assets/images/tzj_model/tzj_model1_energy.svg'
import tzj_model1_package from '@/assets/images/tzj_model/tzj_model1_package.svg'
import tzj_model2_process from '@/assets/images/tzj_model/tzj_model2_process.svg'
import tzj_model2_waste from '@/assets/images/tzj_model/tzj_model2_waste.svg'
import tzj_model3_energy from '@/assets/images/tzj_model/tzj_model3_energy.svg'
import tzj_model3_fire from '@/assets/images/tzj_model/tzj_model3_fire.svg'
import tzj_model3_truck from '@/assets/images/tzj_model/tzj_model3_truck.svg'
import tzj_model_default from '@/assets/images/tzj_model/tzj_model_default.svg'
import tzj_model_root from '@/assets/images/tzj_model/tzj_model_root.svg'
import tzj_model_transport from '@/assets/images/tzj_model/tzj_model_transport.svg'

// 排放源类别对应的视觉样式
const CATEGORY_STYLE = {
  '原/辅材料': { color: '#3b82f6', icon: 'cube' },
  '能源': { color: '#f59e0b', icon: 'energy' },
  '包装材料': { color: '#8b5cf6', icon: 'package' },
  '过程排放': { color: '#F65C5C', icon: 'process' },
  '废弃物': { color: '#94a3b8', icon: 'waste' },
  '能源消耗': { color: '#f59e0b', icon: 'energy' },
  '外购能源': { color: '#00700f', icon: 'power' },
  '外购热力': { color: '#FF3030', icon: 'fire' },
  '产品转运': { color: '#C222C5', icon: 'truck' },
  default: { color: '#5c5c5c', icon: 'default' },
}

// 阶段节点配置
const STAGE_CONFIG = {
  '原材料获取阶段': { icon: 'stage1', label: '原材料获取阶段' },
  '生产制造阶段': { icon: 'stage2', label: '生产制造阶段' },
  '转运和储存阶段': { icon: 'stage3', label: '转运和储存阶段' },
}

const CARD_WIDTH = 280 // 卡片宽度
const CARD_GAP = 16 // 卡片间距
const CARD_HEIGHT = 80 // 卡片高度
const CARD_HEIGHT_WITH_TRANSPORT = 130 // 带运输方式的卡片高度
const STAGE_HEIGHT = 48 // 阶段高度
const ROOT_WIDTH = 400 // 根节点宽度
const ROOT_HEIGHT = 88 // 根节点高度
const COL_GAP = 60 // 列间距
const ROOT_TO_STAGE = 80 // 根节点到阶段距离
const STAGE_TO_ITEMS = 30 // 阶段到明细距离

/** 生成图标 HTML（Vue CLI 会将 .svg 打包为 URL，需用 img 引用） */
function iconSvg(type, size = 24) {
  const icons = {
    stage1: tzj_model_stage1,
    stage2: tzj_model_stage2,
    stage3: tzj_model_stage3,
    cube: tzj_model1_cube,
    energy: tzj_model1_energy,
    package: tzj_model1_package,
    process: tzj_model2_process,
    waste: tzj_model2_waste,
    power: tzj_model3_energy,
    fire: tzj_model3_fire,
    truck: tzj_model3_truck,
    transport: tzj_model_transport,
    root: tzj_model_root,
    default: tzj_model_default,
  }
  const src = icons[type] || icons.default
  return `<img class="modeling-icon-img" src="${src}" width="${size}" height="${size}" alt="" draggable="false" />`
}

/** 格式化数量显示 */
function formatQuantity(qty, unit) {
  if (!qty) return ''
  const num = Number(String(qty).replace(/,/g, ''))
  const formatted = Number.isNaN(num) ? qty : num.toLocaleString('zh-CN')
  return unit ? `${formatted} ${unit}` : formatted
}

/** 判断是否为有效数据行 */
function isValidRow(row) {
  return row && (row['排放源名称'])
}

/** 计算卡片高度 */
function getCardHeight(row) {
  return row['运输方式'] && row['运输距离'] ? CARD_HEIGHT_WITH_TRANSPORT : CARD_HEIGHT
}

let shapesRegistered = false // 是否已注册自定义HTML节点

/** 注册自定义 HTML 节点 */
function registerShapes() {
  if (shapesRegistered) return
  shapesRegistered = true

  // 根节点
  Shape.HTML.register({
    shape: 'modeling-root',
    width: ROOT_WIDTH,
    height: ROOT_HEIGHT,
    effect: ['data'], // 数据绑定
    html(cell) {
      const { title, declaredUnit, output, badge } = cell.getData()
      const div = document.createElement('div')
      div.className = 'modeling-root-node'
      div.innerHTML = `
        <div class="modeling-root-icon">${iconSvg('root')}</div>
        <div class="modeling-root-content-container">
          <div class="modeling-root-top">
            <div class="modeling-root-title">${title}</div>
            <div class="modeling-root-badge">${badge}</div>
          </div>
          <div class="modeling-root-bottom">
            <div class="modeling-root-sub">声明单位：${declaredUnit}</div>
            <div class="modeling-root-output">产品产量：${output}</div>
          </div>
        </div>
      `
      return div
    },
  })

  // 阶段节点
  Shape.HTML.register({
    shape: 'modeling-stage',
    width: CARD_WIDTH,
    height: STAGE_HEIGHT,
    effect: ['data'], // 数据绑定
    html(cell) {
      const { label, icon } = cell.getData()
      const div = document.createElement('div')
      div.className = 'modeling-stage-node'
      div.innerHTML = `
        <span class="modeling-stage-icon">${iconSvg(icon)}</span>
        <span class="modeling-stage-label">${label}</span>
      `
      return div
    },
  })

  // 明细节点
  Shape.HTML.register({
    shape: 'modeling-item',
    width: CARD_WIDTH,
    height: CARD_HEIGHT,
    effect: ['data'], // 数据绑定
    html(cell) {
      const data = cell.getData()
      const { name, quantity, color, icon, transport } = data
      const hasTransport = !!transport
      const div = document.createElement('div')
      div.className = 'modeling-item-node'
      div.style.height = hasTransport ? `${CARD_HEIGHT_WITH_TRANSPORT}px` : `${CARD_HEIGHT}px`
      div.innerHTML = `
        <div class="modeling-item-accent" style="background:${color}"></div>
        <div class="modeling-item-body">
          <div class="modeling-item-main">
            <span class="modeling-item-icon">${iconSvg(icon)}</span>
            <div class="modeling-item-text">
              <div class="modeling-item-name">${name}</div>
              <div class="modeling-item-qty">${quantity}</div>
            </div>
          </div>
          ${hasTransport ? `
            <div class="modeling-item-transport">
              ${iconSvg('transport')}
              <span>${transport}</span>
            </div>
          ` : ''}
        </div>
      `
      return div
    },
  })
}

/** 注入节点样式 */
function injectStyles() {
  if (document.getElementById('modeling-graph-styles')) return
  const style = document.createElement('style')
  style.id = 'modeling-graph-styles'
  style.textContent = `
    .modeling-root-node {
      position: relative;
      display: flex;
      align-items: center;
      gap: 14px;
      width: 100%;
      height: 100%;
      padding: 16px 20px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);
      box-sizing: border-box;
    }
    .modeling-root-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 46px;
      height: 46px;
      background: #f1f5f9;
      border-radius: 8px;
      flex-shrink: 0;
    }
    .modeling-root-content-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    .modeling-root-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }
    .modeling-root-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }
    .modeling-root-title { font-size: 18px; font-weight: 600; color: #0f172a; }
    .modeling-root-badge { padding: 2px 20px; background-color: #20C55C56; border: 1px solid #20C55C; border-radius: 24px; font-size: 13px; color: #20C55C; }
    .modeling-root-sub { font-size: 14px; color: #334155; }
    .modeling-root-output { font-size: 14px; color: #334155; margin-right: 10px; }

    .modeling-stage-node {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 1px 6px rgba(15, 23, 42, 0.06);
      box-sizing: border-box;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', sans-serif;
    }
    .modeling-stage-icon { display: flex; align-items: center; }
    .modeling-stage-label { font-size: 14px; font-weight: 500; color: #334155; }

    .modeling-item-node {
      display: flex;
      width: 100%;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 1px 6px rgba(15, 23, 42, 0.06);
      overflow: hidden;
      box-sizing: border-box;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', sans-serif;
    }
    .modeling-item-accent { width: 4px; flex-shrink: 0; }
    .modeling-item-body { flex: 1; display: flex; flex-direction: column; min-width: 0; }
    .modeling-item-main {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 14px 10px;
      flex: 1;
    }
    .modeling-item-icon { display: flex; align-items: center; flex-shrink: 0; }
    .modeling-item-text { text-align: left; min-width: 0; }
    .modeling-item-name { font-size: 14px; font-weight: 500; color: #0f172a; line-height: 1.3; }
    .modeling-item-qty { margin-top: 2px; font-size: 12px; color: #64748b; }
    .modeling-item-transport {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0 10px 10px;
      padding: 6px 10px;
      background: #ecfdf5;
      border-radius: 6px;
      font-size: 12px;
      color: #15803d;
    }
    .modeling-icon-img { display: block; flex-shrink: 0; }
  `
  document.head.appendChild(style)
}

/** 创建 X6 画布实例 */
export function createModelingGraph(container, jsonData) {
  registerShapes()
  injectStyles()

  const { width, height } = container.getBoundingClientRect()

  const graph = new Graph({
    container,
    width: width || 800,
    height: height || 560,
    // 关闭 autoResize，避免 ResizeObserver 与 zoomToFit 循环触发 dev overlay 报错
    autoResize: false,
    panning: true,
    mousewheel: {
      enabled: true,
      modifiers: ['ctrl', 'meta'],
    },
    background: { color: '#f4f6f8' },
    grid: false,
    interacting: {
      nodeMovable: false,
      edgeMovable: false,
    }
  })

  buildGraph(graph, jsonData)

  // 等 DOM 布局稳定后再居中缩放，避免 ResizeObserver 循环
  requestAnimationFrame(() => {
    graph.centerContent()
    graph.zoomToFit({ padding: 20, maxScale: 1 })
  })

  return graph
}

/** 同步画布尺寸到容器 */
export function resizeModelingGraph(graph, container) {
  if (!graph || !container) return
  const { width, height } = container.getBoundingClientRect()
  if (width > 0 && height > 0) {
    graph.resize(width, height)
  }
}

/** 连线通用样式 */
const EDGE_LINE_ATTRS = {
  line: {
    stroke: '#cbd5e1',
    strokeWidth: 1.5,
    targetMarker: null,
  },
}

/** 同列垂直直线（阶段→明细、明细间） */
function addVerticalEdge(graph, sourceId, targetId) {
  graph.addEdge({
    source: { cell: sourceId, anchor: 'bottom' },
    target: { cell: targetId, anchor: 'top' },
    connector: { name: 'normal' },
    attrs: EDGE_LINE_ATTRS,
  })
}

/** 根节点到阶段：正交折线（下→横→下），避免 orth/rounded 产生 S 弯 */
function addBranchEdge(graph, sourceId, sourceCenterX, targetId, targetCenterX, busY) {
  graph.addEdge({
    source: { cell: sourceId, anchor: 'bottom' },
    target: { cell: targetId, anchor: 'top' },
    vertices: [
      { x: sourceCenterX, y: busY },
      { x: targetCenterX, y: busY },
    ],
    connector: { name: 'normal' },
    attrs: EDGE_LINE_ATTRS,
  })
}

/** 根据 modeling.json 构建节点与连线 */
function buildGraph(graph, jsonData) {
  const data = jsonData
  const items = (data.items || []).map((sheet) => ({
    ...sheet,
    data: (sheet.data || []).filter(isValidRow),
  }))

  const colCount = items.length // 列数（阶段数）
  const colXs = items.map((_, i) => 0 + i * (CARD_WIDTH + COL_GAP)) // 列x坐标
  const totalWidth = colCount > 0 ? colXs[colCount - 1] + CARD_WIDTH : ROOT_WIDTH // 总宽度
  const rootX = (totalWidth - ROOT_WIDTH) / 2 // 根节点x坐标
  const rootY = 40 // 根节点y坐标

  // 根节点
  const root = graph.addNode({
    id: 'root',
    shape: 'modeling-root',
    x: rootX,
    y: rootY,
    width: ROOT_WIDTH,
    height: ROOT_HEIGHT,
    data: {
      title: data.product_name || '未知',
      declaredUnit: data.declaration_unit || '未知',
      output: data.product_output || '未知',
      badge: data.system_boundary || '未知',
    },
  })

  const stageY = rootY + ROOT_HEIGHT + ROOT_TO_STAGE // 阶段y坐标
  const rootCenterX = rootX + ROOT_WIDTH / 2 // 根节点中心x坐标
  const rootBottomY = rootY + ROOT_HEIGHT // 根节点底部y坐标
  const branchBusY = rootBottomY + ROOT_TO_STAGE / 2 // 分支总线y坐标

  items.forEach((sheet, colIndex) => {
    // 阶段配置
    const stageConf = STAGE_CONFIG[sheet.sheetName] || {
      icon: 'default',
      label: sheet.sheetName,
    }
    const colX = colXs[colIndex] // 列x坐标

    // 阶段节点
    const stageNode = graph.addNode({
      id: `stage-${colIndex}`,
      shape: 'modeling-stage',
      x: colX,
      y: stageY,
      width: CARD_WIDTH,
      height: STAGE_HEIGHT,
      data: {
        label: stageConf.label,
        icon: stageConf.icon,
      },
    })

    const stageCenterX = colX + CARD_WIDTH / 2 // 阶段中心x坐标
    // 分支连线
    addBranchEdge(
      graph,
      root.id,
      rootCenterX,
      stageNode.id,
      stageCenterX,
      branchBusY,
    )

    let itemY = stageY + STAGE_HEIGHT + STAGE_TO_ITEMS // 明细y坐标
    let prevItemId = null

    sheet.data.forEach((row, rowIndex) => {
      const category = row['排放源类别'] || '' // 排放源类别
      const style = CATEGORY_STYLE[category] || CATEGORY_STYLE.default
      const transport =
        row['运输方式'] && row['运输距离']
          ? `${row['运输方式']}运输 ${row['运输距离']}${row['距离单位'] || 'km'}`
          : null
      const cardHeight = getCardHeight(row)
      const itemId = `item-${colIndex}-${rowIndex}`

      graph.addNode({
        id: itemId,
        shape: 'modeling-item',
        x: colX,
        y: itemY,
        width: CARD_WIDTH,
        height: cardHeight,
        data: {
          name: row['排放源名称'],
          quantity: formatQuantity(row['数量'], row['单位']),
          color: style.color,
          icon: style.icon,
          transport,
        },
      })

      if (rowIndex === 0) {
        addVerticalEdge(graph, stageNode.id, itemId)
      } else {
        addVerticalEdge(graph, prevItemId, itemId)
      }

      prevItemId = itemId
      itemY += cardHeight + CARD_GAP
    })
  })
}
